interface I_TypeProps {
  id: number;
  label: string;
  value: string;
}

export enum E_USERS_TYPES_ID {
  SUPER_ADMIN = 8,
  ADMIN = 6,
  BROKER = 1,
  BROKER_MANAGER = 9,
  SENIOR = 2,
  JUNIOR = 3,
  CLIENT = 5
}

export enum E_USERS_TYPES_VALUE {
  SUPER_ADMIN = "SUPER_ADMIN",
  ADMIN = "ADMIN",
  BROKER = "BROKER",
  BROKER_MANAGER = "BROKER_MANAGER",
  SENIOR = "SENIOR",
  JUNIOR = "JUNIOR",
  CLIENT = "CLIENTE"
}

export const C_USER_TYPE: { [key: string | number]: I_TypeProps } = {
  SUPER_ADMIN: {
    id: E_USERS_TYPES_ID.SUPER_ADMIN,
    value: E_USERS_TYPES_VALUE.SUPER_ADMIN,
    label: "Super Administrador"
  },
  ADMINISTRATOR: {
    id: E_USERS_TYPES_ID.ADMIN,
    value: E_USERS_TYPES_VALUE.ADMIN,
    label: "Administrador"
  },

  BROKER_MANAGER: {
    id: E_USERS_TYPES_ID.BROKER_MANAGER,
    value: E_USERS_TYPES_VALUE.BROKER_MANAGER,

    label: "Broker Manager"
  },

  BROKER: {
    id: E_USERS_TYPES_ID.BROKER,
    value: E_USERS_TYPES_VALUE.BROKER,
    label: "Broker"
  },

  SENIOR: {
    id: E_USERS_TYPES_ID.SENIOR,
    value: E_USERS_TYPES_VALUE.SENIOR,

    label: "Asociado Senior"
  },

  JUNIOR: {
    id: E_USERS_TYPES_ID.JUNIOR,
    value: E_USERS_TYPES_VALUE.JUNIOR,
    label: "Asociado Junior"
  },

  CLIENT: {
    id: E_USERS_TYPES_ID.CLIENT,
    value: E_USERS_TYPES_VALUE.CLIENT,
    label: "Cliente"
  },

  ERROR: {
    id: 0,
    value: "error",
    label: "Error"
  }
};

export const O_USER_TYPE: { [key: string | number]: I_TypeProps } = {
  [C_USER_TYPE.SUPER_ADMIN.id]: C_USER_TYPE.SUPER_ADMIN,
  [C_USER_TYPE.SUPER_ADMIN.value]: C_USER_TYPE.SUPER_ADMIN,
  [C_USER_TYPE.SUPER_ADMIN.label]: C_USER_TYPE.SUPER_ADMIN,

  [C_USER_TYPE.ADMINISTRATOR.id]: C_USER_TYPE.ADMINISTRATOR,
  [C_USER_TYPE.ADMINISTRATOR.value]: C_USER_TYPE.ADMINISTRATOR,
  [C_USER_TYPE.ADMINISTRATOR.label]: C_USER_TYPE.ADMINISTRATOR,

  [C_USER_TYPE.BROKER.id]: C_USER_TYPE.BROKER,
  [C_USER_TYPE.BROKER.value]: C_USER_TYPE.BROKER,
  [C_USER_TYPE.BROKER.label]: C_USER_TYPE.BROKER,

  [C_USER_TYPE.BROKER_MANAGER.id]: C_USER_TYPE.BROKER_MANAGER,
  [C_USER_TYPE.BROKER_MANAGER.value]: C_USER_TYPE.BROKER_MANAGER,
  [C_USER_TYPE.BROKER_MANAGER.label]: C_USER_TYPE.BROKER_MANAGER,

  [C_USER_TYPE.SENIOR.id]: C_USER_TYPE.SENIOR,
  [C_USER_TYPE.SENIOR.value]: C_USER_TYPE.SENIOR,
  [C_USER_TYPE.SENIOR.label]: C_USER_TYPE.SENIOR,

  [C_USER_TYPE.JUNIOR.id]: C_USER_TYPE.JUNIOR,
  [C_USER_TYPE.JUNIOR.value]: C_USER_TYPE.JUNIOR,
  [C_USER_TYPE.JUNIOR.label]: C_USER_TYPE.JUNIOR,

  [C_USER_TYPE.CLIENT.id]: C_USER_TYPE.CLIENT,
  [C_USER_TYPE.CLIENT.value]: C_USER_TYPE.CLIENT,
  [C_USER_TYPE.CLIENT.label]: C_USER_TYPE.CLIENT,

  [C_USER_TYPE.ERROR.id]: C_USER_TYPE.CLIENT,
  [C_USER_TYPE.ERROR.value]: C_USER_TYPE.CLIENT,
  [C_USER_TYPE.ERROR.label]: C_USER_TYPE.CLIENT
};

export const TYPE_USER_ARRAY = [
  C_USER_TYPE.SUPER_ADMIN,
  C_USER_TYPE.ADMINISTRATOR,
  C_USER_TYPE.BROKER,
  C_USER_TYPE.BROKER_MANAGER,
  C_USER_TYPE.SENIOR,
  C_USER_TYPE.JUNIOR,
  C_USER_TYPE.CLIENT
];
